import Link from 'next/link';
import { useRouter } from 'next/router';
import cn from 'classnames';
import { useGetGlobalSettings } from 'hooks';

import styles from './Navigation.module.scss';
import { useLayoutContext } from '../../../../components/LayoutContext/LayoutContext';

export const Navigation = () => {
  const { asPath } = useRouter();
  const { headerMenuItems } = useLayoutContext();

  const settings = useGetGlobalSettings();

  const headerMenuItemsNodes = headerMenuItems?.nodes || [];

  const loginLink = settings?.loginLink || 'https://www.landr.com/';

  const LoginLabel = () => {
    const loginLabel = settings?.loginLabel || 'Login or Register';

    return (
      <li>
        <a
          href={loginLink}
          className={cn(styles.menuItem, styles.cta)}
          target="_blank"
          rel="noreferrer"
        >
          {loginLabel}
        </a>
      </li>
    );
  };

  return (
    <nav className={styles.root}>
      <ul>
        {headerMenuItemsNodes.map((item) => {
          if (item?.id && item.path && item.label) {
            const isActive =
              asPath !== '/'
                ? item.path.startsWith(asPath)
                : item.path === asPath;

            return (
              <li
                className={cn(styles.menuItem, {
                  [styles.active]: isActive,
                })}
                key={item.id}
              >
                <Link href={item.path}>{item.label}</Link>
              </li>
            );
          }

          return null;
        })}
        <LoginLabel />
      </ul>
    </nav>
  );
};
